/// <amd-module name="SuiteCommerce.CookieConsent.Modal.Configuration"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.CookieConsent.Modal.Configuration", ["require", "exports", "SuiteCommerce.CookieConsent.Common.Configuration"], function (require, exports, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ModalConfiguration = /** @class */ (function (_super) {
        __extends(ModalConfiguration, _super);
        function ModalConfiguration() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(ModalConfiguration, "thirdPartyCookiesText", {
            get: function () {
                return this.get('cookieConsent.thirdPartyCookiesText') || '';
            },
            enumerable: true,
            configurable: true
        });
        return ModalConfiguration;
    }(Configuration_1.Configuration));
    exports.ModalConfiguration = ModalConfiguration;
});
